const DEPLOY_INFO = {
  branchName: '',
  deployedAt: '2024-05-15 10:50:34 GMT'
};

export default DEPLOY_INFO;
